module.exports = __webpack_public_path__ + "static/media/ic_notification_close.1ec08dd8.svg";